import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Style
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import submit from './submit';
import validate from './validate';

// Translation
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import messages from '../../../locale/jsonMessages';
import CommonFormComponent from '../../CommonField/CommonFormComponent';

import cs from '../../../components/commonStyle.css';
import s from './SearchSettingsForm.css';
class SearchSettingsForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    const { initialize, initialValues } = this.props;
    if (initialValues != undefined) {
      initialize(initialValues);
    }
  }



  render() {
    const { meta: { touched, error } = {}, handleSubmit, submitting, dispatch, title } = this.props;
    const { base, availableCurrencies } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer siteAdminCenterContainerBox' >
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.searchSettings} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          <div className="oneColumnGrid">
            <Field
              name="minPrice"
              type="text"
              component={CommonFormComponent}
              labelText={formatMessage(messages.minimumPrice)}
              placeholder={formatMessage(messages.minimumPrice)}
              inputClass='commonInputField'
              maxLength={15}
              isRequiredInput
            />

            <Field name="maxPrice"
              type="text"
              component={CommonFormComponent}
              placeholder={formatMessage(messages.maximumPrice)}
              labelText={formatMessage(messages.maximumPrice)}
              inputClass='commonInputField'
              maxLength={15}
              isRequiredInput
            />

            <Field name="priceRangeCurrency"
              inputClass='commonSelectField'
              labelText={formatMessage(messages.priceRangeCurrency)}
              component={CommonFormComponent}
              placeholder={formatMessage(messages.priceRangeCurrency)} >
              {
                availableCurrencies != null && availableCurrencies.length > 0 && availableCurrencies.map((currency, key) => {
                  if (currency.isEnable === true) {
                    return <option key={key} value={currency.symbol}>{currency.symbol}</option>
                  }
                })
              }
            </Field>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary, cs.btnMediumSpace)} type="submit" disabled={submitting} >
              <FormattedMessage  {...messages.save} /></Button>
          </div>
        </form>
      </div>
    );
  }

}

SearchSettingsForm = reduxForm({
  form: 'SearchSettingsForm', // a unique name for this form
  validate
})(SearchSettingsForm);

const mapState = (state) => ({
  availableCurrencies: state.currency.availableCurrencies,
  base: state.currency.base,
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(SearchSettingsForm)));